<div class="row clearfix" style="z-index: 6000;">
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <div class="body">
          <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <h3 style="text-align: center;">{{ data.message }}</h3>
              </div>
            </div>

          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2 confirm-actions" style="margin-top: 20px; text-align: center;">
              <button class="btn-space" type="button" style="border: 1px solid #8AA0CC; color: #8AA0CC;" mat-button [mat-dialog-close]="false">{{ cancelLabel }}</button>
              <button class="btn-space primaryButton" type="button" mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{ confirmLabel }}</button>
            </div>
          </div>
      </div>
  </div>
</div>
